
export const IS_LOADING = 'IS_LOADING';
export const ERROR = 'ERROR';

export const TYPING_TIMEOUT = 800;//ms
export const MULTIPLE_CLICK_TIMEOUT = 500;

export const ACCEPTED_CHROME_VERSION = 70

export const IMG_EXTENSION_TYPES = [
    "png",
    "jpg",
    "jpeg",
];

export const PDF_EXTENSION_TYPE = "pdf";

export const MYOPEN = "MyOpen";
export const KEYSTONE = "MyOpen keystone";
export const EXTRANET = "Extranet"

export const ALL_SELECT_OPTION = "ALL";
export const NO_VALUE = -1;

export const NEWS_NOTIF_DURATION = 10;//s
export const MAX_NOTIF_CLOSE_NUMBER = 2//On considère la notification comme lu après MAX_NOTIF_CLOSE_NUMBER fermetures de popup

export const IRIS_LINK = "https://iris.dalkiafroidsolutions.com/accueil/";
export const WEBSITE_LINK = "https://www.dalkiafroidsolutions.com/";
export const CONTACT_LINK = "https://www.dalkiafroidsolutions.com/contact";
export const WORKORDER_PHONE_NUMBER = "0 825 825 390";

export const CURRENCY_SYMBOL = "€";